<template>
  <el-row class="alltext" :style="{height:set_page.all_height}">

      <el-col :span="20" :offset="2">
        <el-table
          border
          :data="info.list.list"
          style="width: 100%"
          :height=set_page.table_height>
          <el-table-column
            prop="name"
            label="试卷名称"
            >
            <template slot="header" slot-scope="scope">
               <el-input v-model="input" size="mini" @keyup.enter.native="input_change()" placeholder="输入关键字搜索" />
             </template>
          </el-table-column>
          <el-table-column
            prop="a_id"
            label="发布人"
            >
          </el-table-column>
          <el-table-column
            prop="c_time"
            label="发布时间">
          </el-table-column>
          <el-table-column
            prop="companyee"
            label="人数">
          </el-table-column>
          <el-table-column
              label="员工试卷详情">
              <template slot-scope="scope" style="display: flex;justify-content: center;align-items: center;">
                <el-button round @click="operation(scope.row,'see')" >查看</el-button>
              </template>
          </el-table-column>
          <el-table-column
            prop="companyee"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">启用中</span>
              <span v-if="scope.row.status==0" style="color: orange;">已禁用</span>
              <span v-if="scope.row.status==-1" style="color: red;">已删除</span>
            </template>
          </el-table-column>
           <el-table-column
                fixed="right"
                label="操作"
                width="150">
                <template slot-scope="scope" v-if="scope.row.status!=-1">
                  <el-button @click="operation(scope.row,'retrieval')" type="text" size="small">检索</el-button>
                  <el-button type="text" v-if="scope.row.status!=0" size="small" @click="operation(scope.row,'disable')" style="color: orange;">禁用</el-button>
                  <el-button @click="operation(scope.row,'del')" v-if="scope.row.status!=0" type="text" size="small" style="color: red;">删除</el-button>
                </template>
              </el-table-column>
        </el-table>
        <el-pagination
             class="fenye"
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="info.currentPage"
             :page-size="info.pageSize"
             :page-sizes="[5, 10, 50, 100]"
             layout="total, sizes, prev, pager, next, jumper"
             :total="info.total">
           </el-pagination>
      </el-col>
      <el-dialog
        title="检索"
        :visible.sync="set_page.retrieval_dialogVisible"
         width="50%"
        >
        <span>总人数：{{set_page.retrieval.length}}</span>
        <span style="color: red;margin-left: 1.25rem;">失败人数：{{set_page.false_count}}</span>
         <el-table
            :data="set_page.retrieval"
             tooltip-effect="dark"
            style="width: 100%"
             max-height="300"
             :key="set_page.bomkey_all"
            @selection-change="again_Change">
            <el-table-column
              type="selection"
              :selectable="selectable"
              width="55">
            </el-table-column>
            <el-table-column
              label="员工名称"
              prop="name">
            </el-table-column>
            <el-table-column
              label="状态"
              prop="name">
              <template slot-scope="scope">
                <span v-if="scope.row.status" >成功</span>
                <span v-else style="color: red">失败</span>
              </template>
            </el-table-column>
          </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="again()" >重新发送</el-button>
          <el-button @click="set_page.retrieval_dialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="员工列表"
        :visible.sync="set_page.see_dialogVisible"
         width="50%"
        >
         <el-table
          max-height="300"
          :data="info.user_list"
          style="width: 100%">
          <el-table-column
            label="员工名称"
            prop="companyee">
             </el-table-column>
             <el-table-column
               label="任务周期"
               prop="companyee">
               <template slot-scope="scope">
                 <span >{{scope.row.e_s_time}}~{{scope.row.e_e_time}}</span>
               </template>
            </el-table-column>\
            <el-table-column
               label="员工完成周期"
               >
               <template slot-scope="scope">
                 <span v-if="scope.row.c_e_time==0">未完成</span>
                 <span  v-else>{{scope.row.c_s_time}}~{{scope.row.c_e_time}}</span>
               </template>
            </el-table-column>
            <el-table-column
               label="考核状态"
              >
               <template slot-scope="scope">
                 <span v-if="scope.row.status==1">未通过</span>
                 <span v-if="scope.row.status==2">通过</span>
               </template>
            </el-table-column>
            <el-table-column
              label="状态"
             >
             <template slot-scope="scope">
               <span v-if="scope.row.status==-1" style="color: red;">已移除</span>
               <span v-else>启用中</span>
             </template>
            </el-table-column>

          <el-table-column
            label="员工操作"
            >
            <template slot-scope="scope" v-if="scope.row.status!=-1">
              <el-button @click="user_page(scope.row,'exam')" type="text" size="small">试卷</el-button>
              <el-button @click="user_page(scope.row,'remove')" style="color: red;" size="small">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="set_page.see_dialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="员工试卷列表"
        :visible.sync="user_page_list.show"
         width="50%"
         :key="user_page_list.key"
        >
         <el-table
          max-height="300"
          :data="user_page_list.list"
          style="width: 100%">
          <el-table-column
            label="时间"
            prop="c_time">
          </el-table-column>
          <el-table-column
            label="分数"
            prop="score"
            >
          </el-table-column>
          <el-table-column
            label="操作"
            >
            <template slot-scope="scope">
              <el-button @click="user_page(scope.row,'user_exam')" type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="user_page_list.show = false">关 闭</el-button>
        </span>
      </el-dialog>
  </el-row>
</template>

<script>
  export default{
    data(){
      return{
        input:'',
        now_item:{},
        info:{
          list:[],
          currentPage:1,//当前页数
          pageSize:10,//一页显示多少条
          total:100,//总条数
          keyword:'',
          user_list:[]
        },
        user_page_list:{
          show:false,
          list:[],
          key:0,
          up_data:{
            num:'',
            companyee:''
          },
        },
         getRowKeys(row) {
            return row.id;
          },
          // 要展开的行，数值的元素是row的key值
          expands: [],

        set_page:{
          bomkey_all:'',
          data:{
            num:'',
            push:'',
            companyee:[],
           },
          all_height:'',
          table_height:'',
          see_dialogVisible:false,
          value:'001',
          input:'',
          retrieval_dialogVisible:false,
          retrieval:[],
          again_list:[],
          false_count:0,
          type_list:[{
            value: '001',
            label: '发布'
          },
          {
            value: '002',
            label: '驳回'
          },
          ]

        }
      }
    },
    mounted(){
      this.set_page.all_height=window.innerHeight   + 'px'
      this.set_page.table_height=window.innerHeight -80 + 'px'
      this.get_info()
    },
    methods:{
      again_Change(val){
        // console.log(val)
        let _this=this
        _this.set_page.again_list=val
      },
      again(){
        let _this=this
        for(let i=0;i<_this.set_page.again_list.length;i++){
          let temp=_this.set_page.again_list[i]
          _this.set_page.data.companyee=[temp]
          console.log(_this.set_page.data)
          _this.axios.post('/v2/c_evaluate/company_exam_push',{data:_this.set_page.data}
          ).then(function(res) {
            for(let j=0;j<_this.set_page.retrieval.length;j++){
              if(_this.set_page.retrieval[j].num==_this.set_page.again_list[i].num){
                if(res.data.code==1){
                  _this.set_page.retrieval[j].status=true
                }
              }
            }
            _this.set_page.bomkey_all++
            })
        }

      },

      user_page(item,type){
        let _this=this
        if(type=='user_exam'){
          window.open('test_distribute_subjeCtresult?num='+item.num,'_blank');
        }else if(type=='remove'){
          // console.log(item.name,'删除试卷')
          let data={
            num:item.num
          }
          _this.axios.post('/v2/c_evaluate/companyee_remove', {
             data:data //注意post请求发送参数的方式和get请求方式是有区别的
           }).then(function(res) {
             if(res.status=='200'){
               if(res.data.code=='1'){
                 _this.$message.success(res.data.msg);
                 _this.exam_push_info(_this.now_item)
               }else{
                 _this.$message.error(res.data.msg);
               }
             }else{
               _this.$message.error('服务器内部错误');
             }
           }).catch(function(error) {
             // _this.$message.error('服务器内部错误');
           });
        }else{
           _this.user_page_list.up_data.companyee=item.a_id
           // console.log( _this.user_page_list.up_data)
           _this.companyee_exam_list()
        }
      },
      companyee_exam_list(){
        let _this=this
        _this.axios.get("/v2/c_evaluate/companyee_exam_list",{params: {
          num:_this.user_page_list.up_data.num,
          companyee: _this.user_page_list.up_data.companyee
          }}).then(function (res) {
            if(res.data.code=='1'){
              _this.user_page_list.list=res.data.data
              if(_this.user_page_list.list.length>0){
                _this.user_page_list.show=true
                _this.user_list.key++
                // console.log(_this.user_page_list.list)
              }else{
                _this.$message.success('该学员还未进行考试')
              }

            }else{
              _this.$message.error(res.data.msg)
            }
        })
      },
      get_info(){
        let _this=this
        _this.axios.get("/v2/c_evaluate/exam_push_list",{params: {
          page:_this.info.currentPage,
          limit:_this.info.pageSize,
          keyword:_this.input
        }}).then(function (res) {
          if(res.data.code=='1'){
            _this.info.list=res.data.data
            _this.info.currentPage=Number(res.data.data.currentPage)
            _this.info.pageSize=Number(res.data.data.pageSize)
            _this.info.total=res.data.data.total
          }else{
            _this.$message.error(res.data.msg)
          }
        })
      },
      input_change(){
        this.get_info()
      },
      operation(item,type){
        let _this=this
        if(type=='see'){
          _this.now_item=item
          _this.exam_push_info(item)
          _this.set_page.see_dialogVisible=true
        }else if(type=='retrieval'){
          // console.log('检索')
          _this.set_page.data.push=item.num
          _this.set_page.data.num=item.e_num
          _this.set_page.retrieval=[]
          _this.check_company_exam_push(item.num)
        }else if(type=='del'){
          // console.log('删除')
          let data={
            num:item.num,
            status:'-1'
          }
          _this.exam_push_status(data)
        }else{
          let data={
            num:item.num,
            status:'0'
          }
          _this.exam_push_status(data)
        }
      },
      exam_push_info(item){
        let _this=this
        // console.log(item)
        _this.axios.get("/v2/c_evaluate/exam_push_info",{params: {
          num:item.num
        }}).then(function (res) {
          if(res.data.code=='1'){
            // console.log(res)
            _this.user_page_list.up_data.num=item.num
            _this.info.user_list=res.data.data
          }else{
            _this.$message.error(res.data.msg)
          }
        })
      },
      exam_push_status(data){
        let _this=this
        _this.axios.post('/v2/c_evaluate/exam_push_status',{data:data}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.get_info()
              _this.$message({
                message: '操作成功',
                type: 'success'
              });
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        })
      },
      check_company_exam_push(num){
        let _this=this
        _this.axios.get('/v2/c_evaluate/check_company_exam_push',{params: {num:num}}
        ).then(function(res) {
          // console.log(res)
          if(res.data.code=='1'){
            _this.set_page.false_count=0
            _this.set_page.retrieval=res.data.data
            for(let i=0;i<_this.set_page.retrieval.length;i++){
              if(!_this.set_page.retrieval[i].status){
                _this.set_page.false_count++
              }
            }
            _this.set_page.retrieval_dialogVisible=true
          }
        })
      },
      post_type_info(data){
        let _this=this
        _this.axios.post('/v2/c_evaluate/change_exam_status',{data:data}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.get_list()
              _this.$message({
                message: '操作成功',
                type: 'success'
              });
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        })
      },
      selectable(row){
       if(row.status){
         return false
       }else{
         return true
       }
      },
      handleSizeChange(val){
      let _this=this
      _this.info.pageSize=val
      _this.get_info()
        },
      handleCurrentChange(val) {
        let _this=this
        _this.info.currentPage=val
        _this.get_info()
       },
    },

  }
</script>

<style scoped>
  .alltext{
    background-color: white;
    height: 100%;
    overflow: auto;
  }
  .fenye{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.625rem;
  }
  .spd-pl-table td,
  .spd-pl-table th.is-leaf {
    border-bottom: 1px solid #cadcff;

  }

</style>



// WEBPACK FOOTER //
// src/view/company/evaluate/test_distribute_info/list.vue